(function () {
  'use strict';

  function switchTab(btn, id) {
    document.querySelectorAll('.sg-tab').forEach(function (t) {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    document.querySelectorAll('.sg-panel').forEach(function (p) {
      p.classList.remove('active');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-selected', 'true');
    var panel = document.getElementById('sg-panel-' + id);
    if (panel) panel.classList.add('active');
  }

  window.sgSwitchTab = switchTab;

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.hash === '#care') {
      var careTab = document.getElementById('sg-care-tab');
      if (careTab) careTab.click();
    }
  });
}());
